<template>
  <div class="order-signature" v-if='order'>
    <div v-show='!readyToSign'>
      <div v-show='!readyAggreement'>
        <p>作業前に…<br/><br/>弊社は、お客さまの回収前の不用品や、クリーニング前のエアコン、お部屋などの写真を、作業前と作業後に撮影させていただきます。<br/>
          また、撮影された写真は、弊社ウェブサイトに広告目的により掲載させていただく場合があります。その場合には、お客様のお名前やご住所などの個人情報は一切掲載いたしません。</p>
        <div class="agree-form">
          <label><input type="radio" name="is_agreed" value='1' v-model='is_agreed'> 同意する</label>
          <label><input type="radio" name="is_agreed" value='2' v-model='is_agreed'> 同意しない</label>
        </div>
        <button class="btn"
                @click='agree'>
          次へ
        </button>
      </div>
      <div v-show='readyAggreement'>
        <p v-html='notes[step]'></p>
        <div class="floating-actions">
          <button class="btn"
                  @click='readyToSign = true'>
            サインする
          </button>
        </div>
      </div>
    </div>
    <div v-show='readyToSign'>
      <div class="signature" v-show='images.length'>
        <img :src="images[0]" alt="">
        <div class="floating-actions">
          <button class='btn' type='button'
                  @click='images = []'>
            更新
          </button>
        </div>
      </div>
      <div class="signature-pad" v-show='images.length == 0'>
        <p>指でサインしてください。</p>
        <div class="signature-pad__canvas-wrapper">
          <canvas ref="pad" height='360' width='360'></canvas>
        </div>
        <div class="floating-actions">
          <button class="btn btn-danger" type='button'
                  :disabled='loading'
                  @click='reset'>
            書き直す
          </button>
          <button class='btn' type='button'
                  :disabled='loading || !signed'
                  @click='save'>
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SignaturePad from 'signature_pad';

export default {
  props: ['step','order'],
  name:'WorkSignature',
  data: function() {
    let step_num = this.step === 'before' ? 0 : 4;
    let images = this.order ? this.order.info_steps[step_num].images : null;
    return {
      readyToSign: false,
      readyAggreement: this.step !== 'before',
      images: images,
      loading: false,
      signed: false,
      is_agreed: this.order.info_steps[step_num].is_agreed,
      notes: {
        'before': '作業は慎重に行いますが、お客さまのお宅の壁や床、家財などの破損、お客さまのお怪我などのトラブルを「完全にゼロ」にすることはできません。<br><br>そのため弊社は「対人・対物事故による損害を最大1億円まで補償する賠償責任保険」に加入しております。<br><br>万一の際には、作業スタッフに破損した箇所などについてお知らせください。<br><br>作業中でも、作業後でも結構です。<br><br>ご確認いただけましたらサインをお願いいたします。',

        'after': '作業内容はいかがだったでしょうか？<br/><br/>万が一ご不満な点がございましたら、<br/><br/>「直接作業担当者に伝えにくい…。」<br/><br/>と感じましたら本部にご連絡頂けたら電話オペレーターが確認します。<br/><br/>リベラルマーケティング株式会社：050-5306-5033<br/><br/>※上記電話番号をメモしてくださいね。<br/><br/>事実確認後、内容によってはご納得頂けるような対処を検討します。<br/><br/>この度はありがとうございました。<br/><br/>ご確認頂けましたらサインをお願いします。'
      }
    };
  },
  methods: {
    reset: function() {
      this.pad.clear();
      this.signed = false;
    },
    save: async function() {
      let signature = this.pad.toDataURL();

      let signatureSender =
          this.step == 'before' ?
              this.$api.postOrderBeforeWorkSignature :
              this.$api.postOrderAfterWorkSignature;

      let order_id = this.$route.params.id;


      let rqStatus = {
        signature: false,
        allDone: function() {
          if (this.signature && this.invoice_reset !== false && this.bill !== false)
            return true;
          else
            return false;
        }
      };
      this.loading = true;

      // send bill
      if (this.step == 'after') {
        rqStatus.bill = false;

        await this.$api
            .postOrderBill(order_id, this.$$.bill)
            .then(()=>{
              this.$$.bill = undefined;

              rqStatus.bill = true;
              if (rqStatus.allDone()) {
                this.loading = false;
                this.$$.flash();
              }
            })
            .catch(() => {
              this.loading = false;
            })
      }
      if(this.step == 'after' && rqStatus.bill == false){
        this.$router.push({name: 'orderSteps'});
        return false;
      }

      // Send invoice reset
      if (this.$$.invoice_reset) {
        rqStatus.invoice_reset = false;

        this.$api
            .postInvoiceReset(order_id, this.$$.invoice_reset)
            .then((res) => {
              this.$$.invoice_reset = undefined;

              this.order.info_steps = res.data.data.info_steps;
              this.order.order = res.data.data.order;

              rqStatus.invoice_reset = true;
              if (rqStatus.allDone()) {
                this.loading = false;
                this.$$.flash();
              }
            })
            .catch(() => {
              this.loading = false;
            })
      }

      // Send signature
      signatureSender(order_id, signature)
          .then((res) => {
            this.loading = false;
            this.$$.flash();

            this.order.info_steps = res.data.data.info_steps;
            this.order.order      = res.data.data.order;

            var toSteps = () => {
              this.$router.push({name: 'orderReview'})
            };
            if (this.step == 'before') {
              toSteps()
            }
            else {
              this.$router.push({name: 'receipt', params: this.$route.params});
            }

          })
    },
    agree: async function() {
      if (this.is_agreed === null || this.is_agreed === 0) {
        alert('「同意する」「同意しない」のどちらかを選択してください。')
      } else {
        let order_id = this.$route.params.id;

        this.$api
            .agreeOrder(order_id, this.is_agreed)
            .then((res) => {
              this.order.info_steps = res.data.data.info_steps;
              this.order.order = res.data.data.order;
              this.readyAggreement = true;
            })
            .catch(() => {
              this.loading = false;
            })
      }
    }
  },
  created: function() {
    if (!this.order)
      this.$router.push({name: 'orderSteps', params: this.$route.params});
    if (this.step=='after' && !this.$$.bill)
      this.$router.push({name: 'orderSteps', params: this.$route.params})
  },
  mounted: function() {
    if (this.$refs.pad) this.pad = new SignaturePad(this.$refs.pad);
    this.pad.onEnd = () => {
      if (!this.pad.isEmpty())
        this.signed = true;
    };
    this.$$.context({
      previous: 'トップへ',
      title: "ID:"+this.$route.params.id,
      previousRouteName: 'orderSteps',
    });
  }
}
</script>

<style lang='scss'>
.order-signature {
  padding: 16px;
  text-align: center;
  margin-bottom: 100px;
  p {
    text-align: left;
    margin-bottom: .5em;
  }
  .agree-form {
    margin: 10px 0;
    label {
      margin-right: .5em;
    }
  }
  .signature {
    text-align: center;
    img {
      display: block;
      max-width: 100%;
      height: auto;
      margin: 0 auto 1em;
    }
  }
}
</style>